<template>
<div>
  <checkbox v-for="(option, index) in options"
            :key="option.value"
            ref="checkboxes"
            @check="onCheck"
            @uncheck="onUncheck"
            :value="option.value"
            :id="`${id}_${index + 1}`"
            :name="name">
    {{ option.label }}
  </checkbox>
</div>
</template>

<script>
export default {
    props: {
        value: {
            required: true
        },
        options: {
            required: true,
            type: Array,
        },
        id: {
            required: false,
            type: String
        },
        name: {
            required: false,
            type: String
        }
    },
    created: function() {
        if (this.value == null) {
            this.$emit('input', []);
        }
    },
    mounted: function() {
        var unwatch = this.$watch('value', function() {
            if (this.value && this.value.length > 0) {
                _.forEach(this.$refs.checkboxes, function(checkbox) {
                    if (_.includes(this.value, checkbox.value)) {
                        checkbox.check();
                    }
                }.bind(this));
                unwatch();
            }
        });
    },
    methods: {
        onCheck: function(value) {
            if (!_.includes(this.value, value)) {
                this.value.push(value);
            }
        },
        onUncheck: function(value) {
            var i = _.findIndex(this.value, function(each) {
                return each === value;
            });
            if (i !== -1) {
                this.value.splice(i, 1);
            }
        }
    }
};
</script>
